import { Dispatch, SetStateAction } from 'react'
import * as S from './styles'
import { Alert, Modal } from 'components'

export interface ModalExtraMaterialsProps {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  onConfirm: () => void
  loadingConfirm?: boolean
  onReturn?: () => void
  disabled?: boolean
}

export const ModalExtraMaterials = ({
  open,
  setOpen,
  onConfirm,
  onReturn,
  disabled = false
}: ModalExtraMaterialsProps) => {
  const handleConfirm = () => {
    onConfirm()
    setOpen(false)
  }

  const handleReturn = () => {
    onReturn && onReturn()
    setOpen(false)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title="Análise de volume extra"
      modalWidth={500}
      closeAction={handleClose}
      showReturn
      returnIcon={''}
      returnText="Editar pedido"
      returnAction={handleReturn}
      buttonText="Prosseguir"
      buttonAction={handleConfirm}
      buttonDisabled={disabled}
    >
      <S.ModalContent>
        <Alert
          kind="warning"
          title="Atenção!"
          message={
            <S.AlertContent>
              <li>Pedidos com volume extra serão divididos em diferentes OVs.</li>
              <li>
                Mesmo que uma cor tenha estoque disponível, a garantia dela e o envio ao
                SAP serão realizados apenas quando{' '}
                <strong>todos os materiais do pedido forem aprovados.</strong>
              </li>
              <li>
                Após a aprovação, as OVs serão{' '}
                <strong>enviadas automaticamente ao SAP.</strong>
              </li>
            </S.AlertContent>
          }
        />
      </S.ModalContent>
    </Modal>
  )
}
